<template>
<div class='fullscreen' ref="fullscreen">
  <div class="world-wrapper">
    <canvas ref="world" id="world"></canvas>
  </div>
</div>
</template>
<style lang="scss" scoped>
.world-wrapper{
  margin-top:0px;
  text-align: center;
}
.fullscreen{
  overflow: hidden;
  width:100%
}
</style>
<script>
import Matter from 'matter-js'
import decomp from 'poly-decomp'
// const Vertices = Matter.Vertices
// import omikujiTableRaw from '@/assets/omikuji/index'
import _ from '@/assets/lib/my-lodash'
window.decomp = decomp
const World = Matter.World
const Engine = Matter.Engine
const Render = Matter.Render
const Composites = Matter.Composites
// const Body = Matter.Body
const Bodies = Matter.Bodies
// const Events = Matter.Events
// const Constraint = Matter.Constraint
// const Composite = Matter.Composite
const MouseConstraint = Matter.MouseConstraint
const raritySetting = {
  1: 60,
  2: 30,
  3: 15,
  4: 7,
  5: 3
}
const rarityTable = (() => {
  let table = []
  for (let rarity in raritySetting) {
    let rarityArray = _.fill(new Array(raritySetting[rarity]), rarity)
    table = table.concat(rarityArray)
  }
  return table
})()
export default {
  data: function () {
    return {}
  },
  computed: {
  },
  methods: {
    getRarity: function () {
      return _.sample(rarityTable)
    },
    getYagiImgByRarity: function (rarity) {
      const imgs = {
        1: 'yagi-white.png',
        2: 'yagi-lightcyan.png',
        3: 'yagi-skyblue.png',
        4: 'yagi-plum.png',
        5: 'yagi-gold.png'
      }
      return '/static/img/gacha/' + imgs[rarity]
    }
  },
  mounted: function () {
    const app = this
    const canvas = this.$refs.world
    // Setup Matter JS
    const engine = Engine.create()
    const world = engine.world
    const yagiSize = 60
    const worldWidth = this.$refs.fullscreen.clientWidth
    const worldHeight = this.$refs.fullscreen.clientHeight
    const render = Render.create({
      canvas: canvas,
      engine: engine,
      options: {
        width: worldWidth,
        height: worldHeight,
        scale: 0.5,
        background: '#abc',
        wireframes: false,
        yagiImgSrc: '',
        showAngleIndicator: false
      }
    })

    const createYagiBody = function (x, y) {
      const rarity = app.getRarity()
      return Bodies.circle(x, y, yagiSize / 2, {
        density: 0.01 + 0.01 / rarity,
        label: rarity,
        restitution: 0.88,
        friction: 0.01,
        frictionAir: 0.001,
        frictionStatic: 0.01,
        render: {
          sprite: {
            texture: app.getYagiImgByRarity([rarity]),
            xScale: yagiSize / 60,
            yScale: yagiSize / 60
          }
        }
      })
    }
    const yagis = Composites.stack(0, 0, 20, 15, yagiSize, yagiSize, createYagiBody)
    // Add a floor
    const wallWidth = 200
    const leftWall = Bodies.rectangle(0 - wallWidth / 2 + 1, worldHeight / 2, wallWidth, worldHeight * 2, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const rightWall = Bodies.rectangle(worldWidth + wallWidth / 2 - 1, worldHeight / 2, wallWidth, worldHeight * 2, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const topWall = Bodies.rectangle(worldWidth / 2, -wallWidth / 2 - worldHeight / 2, worldWidth, wallWidth, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#000'
      }
    })
    const floor = Bodies.rectangle(worldWidth / 2, worldHeight, worldWidth, wallWidth, {
      isStatic: true, // An immovable object
      render: {
        fillStyle: '#060'
      }
    })

    const mouseConstraint = MouseConstraint.create(engine, { // Create Constraint
      element: canvas,
      constraint: {
        render: {
          visible: true
        },
        stiffness: 0.8
      }
    })
    World.add(world, [
      yagis,
      floor,
      leftWall,
      rightWall,
      topWall,
      mouseConstraint
    ])
    Engine.run(engine)
    Render.run(render)
  }
}
</script>
